// Asset import matchy config for validation and mapping
import type { CsvFileConfig } from '~/app/components/knowledgeBase/componentSchemaManager/ComponentSchemaManager.types';

export const assetImportCsvConfig: CsvFileConfig = {
  name: 'Asset Import',
  description: 'Import assets with required and optional fields',
  fileName: '',
  columns: [
    { key: 'subClientName', title: 'Sub Client Name', required: false },
    { key: 'subClientId', title: 'Sub Client ID', required: false },
    { key: 'siteId', title: 'Site ID', required: false },
    { key: 'siteAdress', title: 'Site Address', required: false },
    { key: 'zoneId', title: 'Zone ID', required: false },
    { key: 'zoneName', title: 'Zone Name', required: false },
    { key: 'assetName', title: 'Asset Name', required: true },
    { key: 'serialNumber', title: 'Serial Number', required: false },
    { key: 'parentAssetId', title: 'Parent Asset ID', required: false },
    { key: 'parentAssetName', title: 'Parent Asset Name', required: false },
    { key: 'installedAt', title: 'Installed At', required: true },
    { key: 'commissionedAt', title: 'Commissioned At', required: false },
  ],
};
